import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import VueFormWizard from "vue-form-wizard/src";
import VueImage from 'v-img';
import RepositoriesFactory from "./repositories/RepositoriesFactory";
import errorHandler from "./plugins/errorHandler";
import swal from "./plugins/swal";
import moment from "./plugins/moment";
import ar from './locales/ar'
import VueTranslatePlugin from 'vue-translate-plugin';
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import WebViewSetTokenCallback from "./assets/js/WebViewSetTokenCallback";
import VueCountryCode from "vue-country-code";
import './assets/css/app.scss'

Vue.config.productionTip = false;

window.setToken = WebViewSetTokenCallback;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueFormWizard);
Vue.use(VueImage);
Vue.use(VueTranslatePlugin);
Vue.use(VueCountryCode);

Vue.locales({
    ar
});
Vue.use(swal);
Vue.use(errorHandler);
Vue.use(moment);

new Vue({
    router,
    render: h => h(App),
    provide: {
        patientRepo: RepositoriesFactory.get('patient'),
        dataRepo: RepositoriesFactory.get('data'),
        dataOnlineRepo: RepositoriesFactory.get('dataOnline'),
        patientOnlineRepo: RepositoriesFactory.get('patientOnline'),
        localStorageRepo: RepositoriesFactory.get('localStorage')
    },
    mounted() {
        const lang = localStorage.getItem('locale') || 'en';
        this.$translate.setLang(lang);
        document.querySelector('body').setAttribute("dir", lang === 'en' ? 'ltr' : 'rtl');
        document.querySelector('html').setAttribute("lang", lang);
    }
}).$mount('#app')

